import { useBusiness } from 'hooks/useBusiness';
import { Activity } from "interfaces/ActivityInterfaces";
import { Box, Typography } from '@mui/material';
import ActivityDuration from 'components/activity-display/activity-content/ActivityDuration';

function ActivityGridItemQuickInfoBar({ activity }: { activity: Activity }) {
	const { getBizConfigVar, activityCategories } = useBusiness();
	const layout = getBizConfigVar('layout');
	
	const useSeparateCategories = getBizConfigVar('useSeparateCategories');
	
	let categoryTitle = null;

	if (!useSeparateCategories) { //Not separating activities by category, so must specify category in activity grid item
		const category = activityCategories.find(category => category.id === activity.categoryId);
		if (category) {
			categoryTitle = category.title;
		}
	}

	const activityHasDuration = activity.duration.days > 1 || activity.duration.hours > 0 || activity.duration.minutes > 0;

	if (!categoryTitle && !activityHasDuration) return null;

	return (
		<>
			{
				layout === 'tiles' && <div style={{ borderTop: '1px solid white', borderColor: 'rgba(255, 255, 255, 0.4)', marginTop: '10px' }} />
			}
			<Box
				sx={{
					padding: '10px 0 0 0',
					display: 'flex',
					justifyContent: 'space-between',
				}}
			>
				{
					categoryTitle ? (
						<Typography>
							{categoryTitle}
						</Typography>
					) : null
				}
				{
					activityHasDuration ? (
						<ActivityDuration activity={activity} short={true} />
					) : null
				}
			</Box>
		</>
	);
}

export default ActivityGridItemQuickInfoBar;